import React, {useEffect, useReducer, useState} from 'react';

import {ScheduleDemoPageResult} from '../../../../server/routes/schedule-demo.js'

interface ScheduleDemoProps {
    server: string;
    pageData: unknown;
}

export default function ScheduleDemo({server, pageData}: ScheduleDemoProps) {

    const typedPageData = pageData as ScheduleDemoPageResult;
    const [calendly, setCalendly] = useState<boolean>(false);

    useEffect(() => {
        if (!calendly) {
			const head: HTMLHeadElement = document.head;
			let script: HTMLElement | null = document.getElementById('calendlyScript');
			if (!script) {
				const newScript: HTMLScriptElement = document.createElement('script');
				newScript.async = true;
				newScript.src = 'https://assets.calendly.com/assets/external/widget.js';
				newScript.id = 'calendlyScript';
				newScript.onload = () => {
					setCalendly(true);
				};
				head.appendChild(newScript);
			} else {
				setCalendly(true);
			}
        }
		return () => {
			const script: HTMLElement | null = document.getElementById('calendlyScript');
			if (script) {
			  script.remove();
			}
		  }
   }, [calendly]);


	return (
        <>     
             <section className="section section-lg reports-body">
                <div className="container">
                    <div className="row row-50">   
                        <div className="col-md-12 col-lg-12 col-xl-12">    
                            <Calendly /> 
                        </div>
                    </div >
                </div> 
            </section>  
        </>
    )
}

function Calendly() {
    /**

    <div 
    className="calendly-inline-widget" data-url="https://calendly.com/webtechsurvey" 
    style={{minWidth: "320px", height: "700px"}}></div>
    <script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async></script>
    
    // style={{minWidth: "1000px", height: "500px"}}>
     */
    return (      
    <>
        <div 
            className="calendly-inline-widget"
            data-resize="true"
            data-url="https://calendly.com/webtechsurvey?hide_landing_page_details=1&hide_gdpr_banner=1" 
            style={{minWidth: "320px", height: "700px"}}>
        </div>
    </>
   )
}



